<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18eFYRk/media/FC-9781645365105.jpg?1720819951435" alt="This image is the cover for the book The Gemini Virus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Gemini Virus
      </h1>
      <p class="bookDescription body article font2">
        <p>Mercedes ‘Misty’ Rose is a wounded ex-marine turned small-time superhero named Lady Mist, using her shapeshifting and tricked out car to protect the city. But when a terrorist called Mantis threatens to unleash a deadly virus, everything changes. Suddenly Misty faces a mayor under fire for negotiating with terrorists, violent riots, newly emerged superhumans, and explosions rocking the town.</p><p>To make matters worse, Misty gains unlikely allies after years flying solo. For mysterious reasons, Mantis harbors a grudge against her specifically. Now Misty struggles to train these new superpowered recruits, lead a budding team, keep her auto shop running, and conduct rescue missions—all while creatively cussing out threats in true military fashion. As enemy attacks intensify, Misty must embrace partners both new and old to stop Mantis, unite a fractured city, and discover why she’s at the center of this chaos. Even with super abilities, saving lives and stopping disasters proves harder when you can’t go it alone.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gino Holland
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:black;background:white;'>Gino Holland grew up and still lives in south-eastern Wisconsin. He began writing at an early age, experimenting with various sorts of mediums and genres before finally settling on science fiction and fantasy in high school. It wasn&rsquo;t until he met his wife, April, and learned about National Novel Writing Month that he began writing in earnest. He has already had one of those endeavors, <em>What You Wish For</em>, published, and it was one of the greatest days of his life.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?483534a0